<template>
	<div class="countdown-component" :class="{ disabled: second > 0 }" @click="onClick">
		<slot v-bind:second="second">
			{{ second <= 0 ? codeMsg : '剩余' + second + 's' }}
		</slot>
	</div>
</template>

<script>
export default {
	name: 'CountDown',
	props: {
		seconds: {
			type: [Number, String],
			default: 60
		},
		codeMsg: {
			type: String,
			default: '获取验证码'
		},
		value: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			timer: '',
			second: 0
		};
	},
	computed: {
		canGetCode() {
			if (this.second > 0) {
				return false;
			} else {
				return true;
			}
		}
	},
	watch: {
		second: {
			handler: function(val) {
				this.$emit('update:value', val)
			}
		}
	},
	created() {},
	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	},
	methods: {
		start() {
			this.second = this.seconds;
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
			this.timer = setInterval(() => {
				this.second--;
				if (this.second <= 0) {
					clearInterval(this.timer);
					this.timer = null;
				}
			}, 1000);
		},
		onClick() {
			this.$emit('click');
		}
	}
};
</script>

<style lang="scss" scoped>
.countdown-component {
	cursor: pointer;
	&.disabled {
		cursor: not-allowed;
		color: #a6a6a6;
		// color: #a6a6a6 !important;
	}
}
</style>
